import { Action } from 'redux';

export interface DetailState {
  loading: boolean;
  //   data: Detail[];
  data: any;
  error: string | null;
}

export const FETCH_DETAILS_REQUEST = 'FETCH_DETAILS_REQUEST';
export const FETCH_DETAILS_SUCCESS = 'FETCH_DETAILS_SUCCESS';
export const FETCH_DETAILS_FAILURE = 'FETCH_DETAILS_FAILURE';

export interface FetchDetailsRequestAction
  extends Action<typeof FETCH_DETAILS_REQUEST> {}

export interface FetchDetailsSuccessAction
  extends Action<typeof FETCH_DETAILS_SUCCESS> {
  payload: any;
}

export interface FetchDetailsFailureAction
  extends Action<typeof FETCH_DETAILS_FAILURE> {
  payload: string;
}

export type DetailsActionType =
  | FetchDetailsRequestAction
  | FetchDetailsSuccessAction
  | FetchDetailsFailureAction;
